import { inject, Injectable } from '@angular/core';
import { Environment } from '../interfaces/environment.interface';
import { ENVIRONMENT } from '../tokens/environment.token';
import { Cookie } from '../enums/cookie.enum';

@Injectable({
	providedIn: 'root',
})
export class CookieService {
	private env = inject<Environment>(ENVIRONMENT);

	setCookie(name: Cookie, expires: string) {
		document.cookie = `${name}=1;expires=${expires};${this.env.cookieDomain}`;
	}

	setCookieWithValue(name: Cookie, value: string, expirationDays: number = 365) {
		const expires = new Date();
		expires.setTime(expires.getTime() + expirationDays * 24 * 60 * 60 * 1000);
		const encodedValue = encodeURIComponent(value);
		document.cookie = `${name}=${encodedValue};expires=${expires.toUTCString()};path=/;${this.env.cookieDomain}`;
	}

	getCookie(name: Cookie): string | null {
		const nameEQ = `${name}=`;
		const cookies = document.cookie.split(';');
		for (const cookie of cookies) {
			const trimmed = cookie.trim();
			if (trimmed.indexOf(nameEQ) === 0) {
				return decodeURIComponent(trimmed.substring(nameEQ.length));
			}
		}
		return null;
	}

	checkCookie(name: Cookie, val: any) {
		return document.cookie.indexOf(`${name}=${val}`) > -1;
	}

	removeCookie(name: Cookie) {
		const expireDate = 'Thu, 01 Jan 1970 00:00:00 GMT';
		this.setCookie(name, expireDate);
	}
}
